export default function Icon({ icon, alt, maxWidth = "28px", maxHeight = "28px", className = "" }) {
    return (
        <img
            src={icon}
            alt={alt}
            className={`${className} max-w-[${maxWidth}] max-h-[${maxHeight}] md:max-w-[${parseInt(maxWidth) > 40 ? maxWidth : '40px'}] md:max-h-[${parseInt(maxHeight) > 40 ? maxHeight : '40px'}]`}
        />
    );
}